<i18n>
{
  "en": {
    "label": {
      "yes": "Yes",
      "no": "No",
      "note": "Note",
      "submit": "Submit",
      "showAnswer": "Display the answers",
      "hideAnswer": "Hide answers",
      "editAnswer": "Modify Answer",
      "answer": "Answer",
      "notes": "Entry details"
    },
    "message": {
      "title": "Confirmation of the work",
      "description": "We have some questions about your work. Thank you for your response. \nNotes will be hidden after the content is confirmed.",
      "ngReasonTitle": "Error has occurred. Please check the error details.",
      "errorMessageTitle": "Your response has been accepted.",
      "errorMessage": "We will confirm the details you have provided.\nClick the Modify Answer button to change your registration details.",
      "criticalErrorMessageTitle": "An error has occurred.",
      "criticalErrorMessage": "Please check the error details and try again.",
      "postMessage": "Your response has been accepted.",
      "postMessage": "We will confirm the details you have provided.",
      "isAgreeRequired": "Answer not selected.",
      "noteMaxLength": "Please enter up to {count} characters in the Notes field.",
      "noteRequired": "Notes field is required.",
      "completeMessage": "Thank you for your answer. \nWe have checked the contents.",
      "confirmMessage": "Thank you for your answer. \nWe are checking the contents.",
      "thanksMessage": "Thank you for your answer. We will check the information you have provided. \nThere is a possibility that we may ask you about the information you have entered. \nIn that case, we would appreciate your cooperation.",
      "doNotEdit": "We are unable to modify this message as we are still checking the contents. Please wait for a while."
    }
  },
  "ja": {
    "label": {
      "yes": "はい",
      "no": "いいえ",
      "note": "記入欄",
      "submit": "回答を登録する",
      "showAnswer": "回答内容を表示する",
      "hideAnswer": "回答内容を非表示にする",
      "editAnswer": "回答を修正する",
      "answer": "回答",
      "notes": "記入内容"
    },
    "message": {
      "title": "作品確認事項",
      "description": "作品への確認事項がございます。ご回答よろしくお願いいたします。\n各種注意事項は、内容を確認後に非表示となります。",
      "ngReasonTitle": "下記内容をご確認ください。",
      "errorMessageTitle": "回答を受け付けました。",
      "errorMessage": "いただいた内容を確認いたします。\n回答を修正するボタンをクリックすると、登録内容を変更できます。",
      "criticalErrorMessageTitle": "エラーが発生しました。",
      "criticalErrorMessage": "エラー内容を確認の上、再度入力をお願いいたします。",
      "postMessageTitle": "回答を受け付けました。",
      "postMessage": "いただいた内容を確認いたします。",
      "isAgreeRequired": "回答が選択されていません。",
      "noteMaxLength": "記入欄は{count}文字以内で入力してください。",
      "noteRequired": "記入欄は必須項目です。",
      "completeMessage": "ご回答ありがとうございます。\n内容を確認いたしました。",
      "confirmMessage": "ご回答ありがとうございます。\n内容を確認中です。",
      "thanksMessage": "ご回答ありがとうございます。内容を確認いたします。\nなお内容について追加でお伺いする場合がございますので、その際はご対応いただきますようお願いいたします。",
      "doNotEdit": "※内容確認中のため修正できません。しばらくおまちください。"
    }
  }
}
</i18n>

<template>
  <v-flex xs12 sm12 md12 lg12 class="workCheckList">
    <!-- タイトルエリア -->
    <div style="display: flex;flex-wrap: wrap;">
      <div class="subheaderTitle">
        <v-icon left color="primary" class="mr-1">info</v-icon>
        {{ $t('message.title') }}
        <a
          :href="'/cp/' + getCampaignCode() + '/me/help#category8'"
          target="_blank"
          style="text-decoration: none;"
        >
          <v-icon class="ml-1 hover-icon" slot="activator" dark color="primary">
            help_outline
          </v-icon>
        </a>
      </div>
      <div style="width: 100%;"></div>
      <div v-if="canAnswerStatus()" class="multiLine">
        <small class="subheaderDescription">
          {{ $t('message.description') }}
        </small>
      </div>
    </div>
    <!-- 情報表示エリア -->
    <div>
      <!-- 回答が全てロック済みでステータスが「追加情報入力待ち」以降場合の表示 -->
      <div
        class="thanksAnswerArea"
        v-if="allLocked() && workCheckCompleteStatus()"
      >
        <span class="multiLine">{{ $t('message.completeMessage') }}</span>
      </div>
      <!-- 回答が全てロック済みでステータスが「追加情報入力待ち」より前場合の表示 -->
      <div class="thanksAnswerArea" v-else-if="allLocked()">
        <span class="multiLine">{{ $t('message.confirmMessage') }}</span>
      </div>
      <!-- 全て回答済みの表示 -->
      <div class="thanksAnswerArea" v-else-if="allAnswered()">
        <span class="multiLine">{{ $t('message.thanksMessage') }}</span>
      </div>
      <!-- NG理由があり、未回答の場合の表示 -->
      <div
        class="allNgReasonArea"
        v-else-if="this.work.workCheckListInfo && getAllNgReason()"
      >
        <span class="multiLine">{{ getAllNgReason() }}</span>
      </div>
    </div>
    <v-btn
      small
      color="primary"
      v-if="!showAnswerd()"
      @click="showAnswer = true"
    >
      {{ $t('label.showAnswer') }}
    </v-btn>
    <v-btn
      small
      color="primary"
      v-else-if="showAnswer === true"
      @click="showAnswer = false"
    >
      {{ $t('label.hideAnswer') }}
    </v-btn>
    <!-- 回答エリア -->
    <div v-if="showAnswerd()">
      <div
        v-for="(workCheckList, index) in this.work.workCheckLists"
        :key="workCheckList.id"
      >
        <div class="checkArea">
          <div class="contents" v-html="(index + 1) + '. ' + htmlTitle(workCheckList.title)"></div>
          <div class="notes">{{ workCheckList.notes }}</div>
          <!-- 作品確認事項表示状態 -->
          <div
            v-if="
              !canAnswerStatus() ||
                workCheckList.workCheckListAnswer.isLock ||
                (workCheckList.workCheckListAnswer.responseStatus == 1 &&
                  !isEditAnswer[workCheckList.id] == true)
            "
          >
            <div>
              {{ $t('label.answer') }}:
              {{ printIsAgree(workCheckList.workCheckListAnswer.isAgree) }}
              <br />
              {{ $t('label.notes') }}:
              {{ workCheckList.workCheckListAnswer.notes }}
            </div>
            <div style="text-align:right">
              <v-btn
                small
                v-if="
                  canAnswerStatus() &&
                    workCheckList.workCheckListAnswer.responseStatus == 1 &&
                    isEditAnswer[workCheckList.id] != true
                "
                :disabled="workCheckList.workCheckListAnswer.isLock"
                @click="editAnswer(workCheckList.id)"
              >
                <v-icon left class="mr-1">edit</v-icon>
                {{ $t('label.editAnswer') }}
              </v-btn>
              <span
                class="doNotEdit"
                v-if="
                  canAnswerStatus() && workCheckList.workCheckListAnswer.isLock
                "
              >
                <br />※内容確認中のため修正できません。しばらくおまちください。
              </span>
            </div>
          </div>
          <!-- 作品確認事項入力可能状態 -->
          <div v-else>
            <div
              class="ngReasonArea"
              v-if="
                workCheckList.workCheckListAnswer &&
                  workCheckList.workCheckListAnswer.ngReason
              "
            >
              <span class="multiLine">{{
                workCheckList.workCheckListAnswer.ngReason
              }}</span>
            </div>
            <v-radio-group
              v-model="workCheckList.workCheckListAnswer.isAgree"
              row
              style="margin-bottom: -16px;"
            >
              <v-radio :value="true" :label="$t('label.yes')" />
              <v-radio :value="false" :label="$t('label.no')" />
            </v-radio-group>
            <v-text-field
              single-line
              v-model="workCheckList.workCheckListAnswer.notes"
              :label="$t('label.note')"
            ></v-text-field>
          </div>
          <!-- 入力時のエラーメッセージ -->
          <div v-if="errorMessages[workCheckList.id]" class="errorMessage">
            {{ errorMessages[workCheckList.id] }}
          </div>
        </div>
      </div>
      <!-- データリクエスト時の致命的なエラーメッセージ -->
      <div class="criticalErrorArea" v-if="criticalErrorFlag">
        <div class="criticalErrorAreaTitle">
          {{ $t('message.criticalErrorMessageTitle') }}
        </div>
        <span class="multiLine">{{ $t('message.criticalErrorMessage') }}</span>
      </div>
      <!-- データリクエスト時のエラーメッセージ -->
      <div class="errorArea" v-if="errorMessageFlag">
        <div class="errorAreaTitle">{{ $t('message.errorMessageTitle') }}</div>
        <span class="multiLine">{{ $t('message.errorMessage') }}</span>
      </div>
      <div class="errorArea" v-else-if="postFlag">
        <div class="errorAreaTitle">{{ $t('message.postMessageTitle') }}</div>
        {{ $t('message.postMessage') }}
      </div>
      <div class="actionArea">
        <v-btn
          :disabled="!isSubmitButton()"
          color="primary"
          @click="clickButton"
        >
          {{ $t('label.submit') }}
        </v-btn>
      </div>
    </div>
  </v-flex>
</template>

<script>
import { Me } from '@/api';
import { EnumStatuses, EnumWorkCheckListResponseStatus } from '@/enum/enum.js';
import { ConstWorkCheckList } from '@/const/const.js';
import StorageManager from '@/utils/StorageManager';
import AutoLinkUtil from '@/utils/AutoLinkUtil';

export default {
  components: {
    AutoLinkUtil
  },
  props: {
    value: Object //work情報が入る。親コンポーネントからv-modelで指定されたprops
  },
  data() {
    return {
      work: {},
      isEditAnswer: [],
      criticalErrorFlag: false, // ステータスコード403が発生した場合にtrueがセットされる
      errorMessageFlag: false, // ステータスコード400が発生した場合にtureがセットされる
      postFlag: false,
      errorMessages: [],
      showAnswer: null
    };
  },
  methods: {
    htmlTitle(text) {
      return AutoLinkUtil.convert(text)
    },
    // 回答登録処理
    clickButton() {
      // 初期化
      this.criticalErrorFlag = false; // ステータスコード403を記録するフラグをリセット
      // 入力チェック
      this.validation();

      // 作品確認事項回答データ
      let workCheckListAnswers = [];
      for (const workCheckList of this.work.workCheckLists) {
        // 回答状態でないデータは送信しない
        if (
          workCheckList.workCheckListAnswer.isLock ||
          (workCheckList.workCheckListAnswer.responseStatus ==
            EnumWorkCheckListResponseStatus.Answerd &&
            this.isEditAnswer[workCheckList.id] != true)
        ) {
          continue;
        }
        workCheckListAnswers.push({
          work_check_list_id: workCheckList.id,
          workId: this.work.id,
          is_agree: workCheckList.workCheckListAnswer.isAgree,
          notes: workCheckList.workCheckListAnswer.notes
        });
      }
      // 作品確認事項回答データ送信
      Me.postWorkCheckLists(workCheckListAnswers)
        .then(() => {
          this.postFlag = true;
          this.editModeFourceCancel();
        })
        .catch(error => {
          if (error.http.statusCode == 403) {
            // ステータスコード403は、致命的な入力不備によりデータが登録されないエラー
            this.criticalErrorFlag = true; // ステータスコード403を記録
            let dialogMessage = this.$t('message.criticalErrorMessageTitle');
            dialogMessage += '\n' + this.$t('message.criticalErrorMessage');
            alert(dialogMessage);
          } else if (error.http.statusCode == 400) {
            // ステータスコード400は、入力不備はあるがデータ自体は登録されるエラー
            this.errorMessageFlag = true; // ステータスコード400を記録
            // エラー発生時でも回答した場合は、編集モードを解除
            this.editModeFourceCancel();
          } else {
            // 想定外のエラーが発生した場合はメッセージを出力して終了
            alert(error.data.result.message);
          }
        });
    },
    // 入力チェック
    validation() {
      // エラーを初期化
      this.errorMessageFlag = false;

      for (const workCheckList of this.work.workCheckLists) {
        // 再回答する設問のエラーをリセット
        // 個別のエラーを一括でリセットすると、すでにエラーとなっている設問を、再度回答しない場合に、エラーが消えてしまうため個別にリセット
        if (this.isEditAnswer[workCheckList.id] == true) {
          this.errorMessages[workCheckList.id] = '';
        }
        let errorMessage = ''; // 確認事項個別エラーメッセージ
        // 回答の選択状態チェック
        if (workCheckList.workCheckListAnswer.isAgree == null) {
          // エラーメッセージに追加
          errorMessage = this.$t('message.isAgreeRequired');
        }
        // 記入欄の文字数チェック
        if (
          workCheckList.workCheckListAnswer.notes &&
          workCheckList.workCheckListAnswer.notes.length >
            ConstWorkCheckList.MaxNotesLength
        ) {
          // エラーメッセージに追加
          if (errorMessage != '') {
            errorMessage += '\n';
          }
          errorMessage += this.$t('message.noteMaxLength', {
            count: ConstWorkCheckList.MaxNotesLength
          });
        }
        // 記入欄の必須入力チェック
        if (
          workCheckList.isNoteRequired &&
          (workCheckList.workCheckListAnswer.notes === null ||
            workCheckList.workCheckListAnswer.notes === '')
        ) {
          // エラーメッセージに追加
          if (errorMessage != '') {
            errorMessage += '\n';
          }
          errorMessage += this.$t('message.noteRequired');
        }
        // エラーメッセージの内容をセット
        this.$set(this.errorMessages, workCheckList.id, errorMessage);
      }
    },
    // 回答項目を編集状態に遷移
    editAnswer(id) {
      this.$set(this.isEditAnswer, id, true);
    },
    // 設問全てに回答済みの場合trueを返す
    // 回答内容にエラーが出ているかどうかは不問
    allAnswered() {
      if (!this.work.workCheckLists || this.work.workCheckLists.length == 0) {
        return false;
      }
      for (const workCheckList of this.work.workCheckLists) {
        if (
          !workCheckList.workCheckListAnswer ||
          workCheckList.workCheckListAnswer.responseStatus !=
            EnumWorkCheckListResponseStatus.Answerd
        ) {
          return false;
        }
      }
      return true;
    },
    // 事前確認事項が確定となるステータス判定
    workCheckCompleteStatus() {
      // 追加情報入力待ちステータスになった場合は、事前確認事項が確定
      if (this.work.status >= EnumStatuses.WaitingWorkInformationInput) {
        return true;
      }
      return false;
    },
    // 設問全てがロックされた場合trueを返す
    allLocked() {
      if (!this.work.workCheckLists || this.work.workCheckLists.length == 0) {
        return false;
      }
      for (const workCheckList of this.work.workCheckLists) {
        if (
          !workCheckList.workCheckListAnswer ||
          !workCheckList.workCheckListAnswer.isLock
        ) {
          return false;
        }
      }
      return true;
    },
    // 回答可能なステータスか判定
    canAnswerStatus() {
      // 回答可能なステータスはデータ提出待ち〜データ確認済みまでの間
      if (
        this.work.status >= EnumStatuses.WaitingDataSubmission &&
        this.work.status <= EnumStatuses.DataReceived
      ) {
        return true;
      }
      return false;
    },
    // 回答欄表示制御
    // false時は非表示
    showAnswerd() {
      if (this.showAnswer === true) return true; // 表示ボタンが押された場合は無条件で表示する
      if (this.showAnswer === false) return false; // 非表示ボタンが押された場合は非表示とする
      if (this.allLocked()) return false; // 全ての回答がロックされた場合は非表示
      if (!this.canAnswerStatus()) return false; // 回答可能なステータス以外の場合は非表示
      return true;
    },
    // 回答ボタンアクティブ判定
    isSubmitButton() {
      if (!this.canAnswerStatus()) {
        return false;
      }
      if (!this.allAnswered()) {
        return true;
      }
      for (const editAnswer of this.isEditAnswer) {
        if (editAnswer == true) {
          return true;
        }
      }
      return false;
    },
    // 編集モードを全て強制的に解除する
    // 回答後に実行される
    editModeFourceCancel() {
      // 編集モードを解除
      for (const workCheckList of this.work.workCheckLists) {
        this.$set(workCheckList.workCheckListAnswer, 'responseStatus', 1);
        this.$set(this.isEditAnswer, workCheckList.id, false);
      }
    },
    // 回答文字列を出力
    printIsAgree(flag) {
      if (flag === true) {
        return 'はい';
      } else if (flag === false) {
        return 'いいえ';
      } else {
        return '未回答';
      }
    },
    // 全体NG理由を返す
    getAllNgReason() {
      let allNgReason = this.work.workCheckListInfo.ngReason;
      // 個別のNG理由が存在する場合は、全体NG理由にその旨を追記する
      for (let i = 0; i < this.work.workCheckLists.length; i++) {
        let workCheckList = this.work.workCheckLists[i];
        if (
          workCheckList.workCheckListAnswer &&
          workCheckList.workCheckListAnswer.ngReason != ''
        ) {
          if (allNgReason != '') {
            allNgReason += '\n';
          }
          allNgReason += `設問${i + 1}をご確認のうえ、再度ご回答をお願いします`;
        }
      }
      return allNgReason;
    },
    // キャンペーンコードを取得する
    getCampaignCode: () => {
      return StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY');
    }
  },
  beforeMount: function() {
    // 親でv-modelされたvalue値を設定
    this.work = this.value;
    // 未回答時はデータが存在しないので作成しておく
    for (const workCheckList of this.work.workCheckLists) {
      if (!workCheckList.workCheckListAnswer) {
        workCheckList['workCheckListAnswer'] = { isAgree: null, notes: null };
      }
    }
  }
};
</script>

<style scoped>
.workCheckList {
  padding: 20px;
}
.subheaderTitle {
  margin-bottom: 5px;
  font-weight: bold;
}
.subheaderDescription {
  font-size: 12px;
  font-weight: 300;
  text-shadow: none;
}
.thanksAnswerArea {
  padding: 20px;
  margin: 5px;
  border: 1px solid green;
  font-size: 1rem;
  color: green;
}
.allNgReasonArea {
  padding: 10px;
  margin: 5px;
  font-size: 1.2rem;
  font-weight: bold;
  color: white;
  background-color: orangered;
}
.ngReasonArea {
  padding: 10px;
  margin: 5px;
  border: 1px solid red;
  font-size: 1rem;
  color: red;
}
.checkArea {
  padding: 20px;
  margin: 5px;
  border-bottom: 1px solid gray;
  border-bottom-style: dotted;
}

.contents {
  font-size: 1.2rem;
}

.notes {
  font-size: 1rem;
  padding: 4px;
  color: #555555;
}

.ngReason {
  font-size: 1rem;
  color: red;
}

.doNotEdit {
  font-size: 12px;
  font-weight: 300;
  text-shadow: none;
}

.errorArea {
  margin-top: 20px;
  padding: 16px;
  color: green;
  font-size: 1rem;
  width: 100%;
  text-align: center;
  justify-content: center;
}
.errorAreaTitle {
  margin-bottom: 5px;
  font-size: 1.3rem;
  font-weight: 900;
}

.criticalErrorArea {
  margin-top: 20px;
  padding: 16px;
  color: red;
  font-size: 1rem;
  width: 100%;
  text-align: center;
  justify-content: center;
}
.criticalErrorAreaTitle {
  margin-bottom: 5px;
  font-size: 1.3rem;
  font-weight: 900;
}

.errorMessage {
  color: red;
}

.actionArea {
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.multiLine {
  white-space: pre-line;
}
</style>
